import { css } from '@emotion/react';
import React from 'react';

import { Section, SectionItem } from '../../api/api';
import { Icon, IconType } from '../commons/components/icon';

interface OperationalSectionComponentProps {
  section: Section;
}

export const OperationalSectionComponent: React.FC<OperationalSectionComponentProps> = ({
  section,
}) => {
  return (
    <>
      <div aria-level={4} css={styles.title} role="heading">
        {section.name}
      </div>
      <div css={styles.grid} role="list">
        {section.columns?.map((column, idx) => (
          <div key={idx} css={styles.column}>
            {column.items?.map(item => (
              <div key={item.icon} css={styles.row}>
                <SectionItemComponent item={item} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

interface SectionItempComponentProps {
  item: SectionItem;
}

const SectionItemComponent: React.FC<SectionItempComponentProps> = ({ item }) => {
  const textElement = item.link ? (
    <a rel="noreferrer noopener" target="_blank" href={item.link}>
      {item.text}
    </a>
  ) : (
    <span>{item.text}</span>
  );

  return (
    <>
      <Icon ariaHidden="true" type={item.icon as IconType} />
      <div role="listitem">{textElement}</div>
    </>
  );
};

const styles = {
  title: css({
    fontSize: '12px',
    lineHeight: '20px',
  }),
  grid: css({
    display: 'flex',
    fontSize: '12px',
    lineHeight: '20px',
  }),
  column: css({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '50%',
  }),
  row: css({
    display: 'grid',
    gridTemplateColumns: '16px auto',
    columnGap: '10px',
  }),
};
